import {
    RaikoButtonPrimary, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoDatePicker, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoTimePicker,
    RaikoToggleOutlined, showErrorMessage,
    showServerErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import React from "react";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {Chip, TextField} from "@mui/material";
import {ElectionService} from "../../serverService/electionService/ElectionService";

export default function AddNewElections({addNewElectionsToTable}) {

    const groupService = new GroupsService();
    const loading = new LoadingHelper(useLoadingDispatcher());
    const {fundID} = useAuthState()


    useEffect(() => {
        getGroupListFRomService()
    }, [fundID]);


    const [title, setTitle] = useState("");
    const [groupList, setGroupList] = useState([]);
    const [groupSelectedID, setGroupSelectedID] = useState(1);
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState();
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false);
    const [publish, setPublish] = useState(false);
    const [candidatesList, setCandidatesList] = useState([]);
    const [options, setOptions] = useState("");
    const [description, setDescription] = useState("");

    const service = new ElectionService()


    function getGroupListFRomService() {
        loading.show()
        groupService.getGroups(fundID, 0, 1000000)
            .then(
                response => {
                    setGroupList([])
                    response.data.map((item) => {
                        setGroupList(prevState => [...prevState,
                            raikoCustomSelectItemGenerator(item.id, item.name)
                        ])

                    })
                }
            ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const handleDelete = (chipToDelete) => () => {
        setCandidatesList((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };

    function checkAllFields() {
        let state = false
        let message = ""
        if (title.trim().length === 0)
            message = "لطفا عنوان انتخابات را وارد نمایید!"
        else if (groupSelectedID === -1)
            message = "لطفا گروه را انتخاب نمایید!"
        else if (startDate.length !== 10)
            message = "لطفا تاریخ شروع انتخابات را به درستی وارد نمایید!"
        else if (endDate.length !== 10)
            message = "لطفا تاریخ پایان انتخابات را به درستی وارد نمایید!"
        else if (candidatesList.length === 0)
            message = "لطفا نام کاندیدا ها وارد نمایید!"
        else
            state = true
        if (message && message.length > 0)
            showWarningMessage(message)
        return state
    }

    function handleAddNewElection() {
        if (checkAllFields()) {
            setButtonLoading(true)
            service.addNewElection(
                fundID,
                groupSelectedID,
                title,
                startDate,
                startTime,
                endDate,
                endTime,
                publish,
                true,
                candidatesList,
                description
            ).then(
                response => {
                    showSuccessMessage("انتخابات جدید با موفقیت افزوده شد.")
                    addNewElectionsToTable(response)
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setButtonLoading(false)
            })
        }
    }


    console.log("start time is ", startTime ? startTime.toString() : startTime)


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridThreeColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoCustomSelect
                    labelText={"گروه"}
                    setValue={setGroupSelectedID}
                    items={groupList}
                    value={groupSelectedID}/>
                <RaikoDatePicker
                    label={"تاریخ شروع"}
                    date={startDate}
                    setDate={setStartDate}
                />
                <RaikoTimePicker
                    label={"زمان شروع"}
                    time={startTime}
                    setTime={setStartTime}
                />
                <RaikoDatePicker
                    label={"تاریخ پایان"}
                    date={endDate}
                    setDate={setEndDate}
                />
                <RaikoTimePicker
                    label={"زمان پایان"}
                    time={endTime}
                    setTime={setEndTime}
                />
            </RaikoGridThreeColumn>
            <RaikoGridOneColumn>
                <RaikoToggleOutlined
                    checked={publish}
                    setChecked={setPublish}
                    labelText={"انتشار خودکار"}
                />
                <section className={css`display: flex;
                  flex-direction: column`}>
                    <label
                        className={candidatesList.length > 0 ? css`display: block` : css`display: none`}>کاندیدها</label>
                    <div className={css`display: flex;
                      flex-direction: row`}>
                        {candidatesList.map((data) => {
                            return (
                                <Chip
                                    label={data.label}
                                    onDelete={handleDelete(data)}
                                    key={data.key}
                                />
                            )
                        })}

                    </div>

                </section>
                <TextField
                    className="w-100"
                    label="کاندید جدید"
                    helperText="افزودن با اینتر"
                    variant="outlined"
                    value={options}
                    onChange={e => {
                        setOptions(e.target.value)
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            const key = candidatesList.length > 0 ? parseInt(candidatesList[candidatesList.length - 1].key) + 1 : "0"
                            setCandidatesList((prevState => [...prevState, {
                                key: key,
                                label: options
                            }]))
                            setOptions("")
                        }
                    }}

                />
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"توضیحات"}
                    value={description}
                    setValue={setDescription}
                />
            </RaikoGridOneColumn>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    loading={buttonLoading}
                    onClick={handleAddNewElection}
                />
            </RaikoFlexAlignEnd>


        </RaikoGridOneColumn>
    )
}